import { render, staticRenderFns } from "./PrivateAttachmentsOnContactPage.vue?vue&type=template&id=09df602a&"
import script from "./PrivateAttachmentsOnContactPage.vue?vue&type=script&lang=js&"
export * from "./PrivateAttachmentsOnContactPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivateAttachmentsOnContactPage.vue?vue&type=style&index=0&id=09df602a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports